





























helpers = require '../../../helpers.coffee'

view_model = {
  components:
    templatePicker: require '../../templates/picker'

  props: ['reference', 'action', 'templates', 'actions', 'flow', 'options']

  data: ->
    action_parameters: null
    type: 'EmailFlowAction'
    template: @action.template
    previous_template: @action.template
    previous_type: 'EmailFlowAction'
    manual_task_parameters: null
    send_as_reply: @action.send_as_reply

  methods:
    templateChanged: (data)  ->
      @template = data.template
      @emitChange()

    emitChange: ->
      @$emit 'change', { @type, @template, @manual_task_parameters, @reference, @send_as_reply }

    typeChanged: ->
      @type = @action_parameters.type
      @manual_task_parameters = { service: @action_parameters.service }
      if @is_email_flow_action
        @template = @previous_template
        @type = 'TaskFlowAction' if @flow.semi_automatic
      else
        @previous_template = @template

      if this.invalidActionTemplate()
        @action.template_id = null
        @action.template = null
        @template = null
        this.setTemplateKind()

      @emitChange()

    cancelTemplateEdit: (data) ->
      @action_parameters = @previous_type
      @action.template_id = data.action_template_id
      @action.template = @previous_template

    invalidActionTemplate: () ->
      return @action_parameters.service.split('::')[1].toLowerCase() != @action.template?.kind

    setType: (data) ->
      return unless data.reference == @reference and data.type

      if data.type == 'EmailFlowAction'
        @action_parameters = @action_parameters_list[0]
      else
        @action_parameters = @action_parameters_list.filter((action_parameters) ->
          action_parameters.service == data.manual_task_parameters.service)[0]

      @typeChanged()

    toggleSendAsReply: ->
      return if @disabled
      @send_as_reply = !@send_as_reply
      @emitChange()

    setTemplateKind: ->
      if !@action_parameters
        @template_kind = 'email'
      else
        @template_kind = @action_parameters.service.split('::')[1].toLowerCase()  

  computed:
    action_parameters_list: ->
      Task.availableManualTaskServices.filter (manual_task) ->
        manual_task.service.toLowerCase().indexOf('meeting') == -1

    type_options: ->
      for action_parameters in @action_parameters_list
        if action_parameters.type == 'EmailFlowAction' && @flow.semi_automatic
          human_name = action_parameters.human_name + ' manual'
        else
          human_name = action_parameters.human_name
        icon_class = Task.serviceIcons[action_parameters.service]
        { value: action_parameters, text: human_name, icon_class }

    hide_send_as_reply: ->
      return true if !@action.isEmailFlowAction()
      for action in @actions
        return false if action.step < @action.step && action.isEmailFlowAction()
      true

    is_email_flow_action: ->
      @type == 'EmailFlowAction' || @manual_task_parameters.service == Task.emailTaskService.service

    template_kind: ->
      if !@action_parameters
        return 'email'
      else
        return @action_parameters.service.split('::')[1].toLowerCase()

  created: ->
    EventsBus.$on 'FlowTypePicker:Set', @setType
    EventsBus.$emit 'FlowTypePicker:Created', { @reference }

  beforeDestroy: ->
    EventsBus.$off 'FlowTypePicker:Set', @setType

  mounted: ->
    @action_parameters ?= @action_parameters_list[0]
    @previous_type = @action_parameters
    this.setTemplateKind()
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flow_actions/picker/type.vue